const outdatedBrowser = require('exports-loader?outdatedBrowser!outdatedbrowser/outdatedbrowser/outdatedbrowser.js')

document.addEventListener('turbolinks:load', function () {
  outdatedBrowser({
    lowerThan: 'object-fit',
    languagePath: '',
  })
})
